import {
    Group,
    Text
} from "@mantine/core";

export const StripeAmount = (props: { amount: number, currency?: string }) => {
    const {
        amount,
        currency
    } = props;

    if (!currency) {
        return <Text>{(amount / 100).toFixed(2)}</Text>
    }

    return (
        <Group gap={'xs'}>
            <Text>{(amount / 100).toFixed(2)}</Text><Text>{currency}</Text>
        </Group>
    )

}